import { load } from './googleAPIHandler.helpers';

const batchUpdate = async (
  presentationId: string,
  requests: any,
): Promise<any> => {
  await load('slides', 'v1');

  // @ts-expect-error slides
  return gapi.client.slides.presentations.batchUpdate({
    presentationId,
    requests,
  });
};

export { batchUpdate };
